<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" class="App_head"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" class="App_head"></router-view>

    <div class="footer">
      <van-grid clickable :column-num="2">
        <van-grid-item
          :class="$route.path === '/' ? 'active' : 'item'"
          icon="wap-home"
          to="/"
          text="首页"
        />
        <van-grid-item
          :class="$route.path === '/mine' ? 'active' : 'item'"
          icon="manager"
          to="/mine"
          text="我的"
        />
      </van-grid>
    </div>
  </div>
</template>
<script>
import { Row, Col, Grid, GridItem } from "vant";
export default {
  name: "App",
  data() {
    return {
      aaa: "#A10000",
      signInShow: false,
    };
  },
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
  },
  created() {},
  computed: {
    onRoutes() {},
  },
  created() {
    let setmealIndex = this.getUrlParam('setmealIndex')
    if(setmealIndex !== null){
      sessionStorage.setItem('setmealIndex',setmealIndex)
    }
  },
  methods: {
    getUrlParam(name) {//封装方法
      if (!name) return null;
      // 查询参数：先通过search取值，如果取不到就通过hash来取
      var after = window.location.search;
      after = after.substr(1) || window.location.hash.split('?')[1];
      // 地址栏URL没有查询参数，返回空
      if (!after) return null;
      // 如果查询参数中没有"name"，返回空
      if (after.indexOf(name) === -1) return null;
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
      // 当地址栏参数存在中文时，需要解码，不然会乱码
      var r = decodeURI(after).match(reg);
      // 如果url中"name"没有值，返回空
      if (!r) return null;
      return r[2];
    }
  },
};
</script>
<style scoped lang="css">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  background: #f6f3f3;
  min-height: 100vh;
}

.van-tabbar-item--active {
  color: #a10000;
}
.footer {
  position: fixed;
  bottom: 0;
  width: 375px;
  height: 45px;
  background: red;
}

.footer /deep/ .van-grid-item__content {
  padding: 5px !important;
}
.footer /deep/ .van-grid-item__text {
  margin-top: 2px;
}
.active /deep/ .van-grid-item__icon {
  font-size: 18px;
  color: #dc120c;
}
.active /deep/ .van-grid-item__text {
  color: #dc120c;
}
.item /deep/ .van-grid-item__icon {
  font-size: 18px;
  color: #d0c9c9;
}
.item /deep/ .van-grid-item__text {
  color: #d0c9c9;
}
</style>



// WEBPACK FOOTER //
// src/App.vue